const API_URL = '/api/opportunities';

export const getOpportunities = async () => {
    const response = await fetch(API_URL);
    if (!response.ok) {
        throw new Error('Failed to fetch opportunities');
    }
    return response.json();
};

export const createOpportunity = async (opportunityData, token) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(opportunityData)
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || error.error || 'Failed to create opportunity');
    }
    return response.json();
};
export const updateOpportunity = async (id, opportunityData, token) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(opportunityData)
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || error.error || 'Failed to update opportunity');
    }
    return response.json();
};

export const deleteOpportunity = async (id, token) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || error.error || 'Failed to delete opportunity');
    }
    return true;
};
